<script setup lang="ts" generic="T extends string">
import { DgrIcon, type IconTypes } from '@stockmarkteam/donguri-ui';

const props = withDefaults(
  defineProps<{
    segments: { label: string; value: T; icon?: IconTypes }[];
    size?: 'small' | 'medium';
  }>(),
  { size: 'small' },
);

const model = defineModel<T>();
if (model.value === undefined) {
  model.value = props.segments[0].value;
}
</script>
<template>
  <div class="segmented-control" :class="size">
    <button
      v-for="segment in segments"
      :key="segment.value"
      type="button"
      class="c-title-bold--m"
      :class="{ selected: segment.value === model }"
      @click="model = segment.value"
    >
      <DgrIcon
        v-if="segment.icon"
        class="segment-icon"
        :name="segment.icon"
        :keep-fill="false"
      />
      {{ segment.label }}
    </button>
  </div>
</template>
<style scoped lang="scss">
.segmented-control {
  display: flex;
  background: $color-gray400;
  border-radius: 4px;
  color: $color-gray1000;
  width: fit-content;
  height: 24px;

  button {
    background: none;
    height: 22px;
    border: none;
    border-radius: 4px;
    padding: 0 24px;
    margin: 1px;

    &.selected {
      background: #fff;
    }
  }

  &.medium {
    height: auto;

    button {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      height: auto;
      padding: 5px 24px;
      border-radius: 3px;
    }

    // DgrIcon のサイズ指定に 20px がないので、デザインの値に上書きする。
    .segment-icon {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
